import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  withStyles
} from '@material-ui/core';
import React from 'react';

import styles from './styles';
import { translate } from '../../i18n/I18nProvider';

const CustomAccordion = ({
  classes,
  children,
  labelId = 'MORE_INFO',
  label = null,
  style = {},
  onChange,
  unmountOnExit = false
}) => {
  const title = label ? label : translate(labelId);

  return (
    <Accordion
      className={classes.accordion}
      square={true}
      elevation={0}
      style={style}
      onChange={onChange}
      TransitionProps={{ unmountOnExit }}
    >
      <AccordionSummary
        classes={{ expanded: classes.expanded }}
        className={classes.accordionSummary}
        expandIcon={<i className="fa fa-angle-down" />}
      >
        <div>{title}</div>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default withStyles(styles)(CustomAccordion);
